export default function SvgVertical() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        cursor="pointer"
        fill="#000"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 64 64"
        >
      <path fill="none" d="M-256 -64H1024V736H-256z"></path>
      <g>
        <g>
          <circle cx="32.026" cy="12.028" r="4"></circle>
          <circle cx="32.026" cy="52.028" r="4"></circle>
          <circle cx="32.026" cy="32.028" r="4"></circle>
        </g>
      </g>
    </svg>
  </>
  );
}